enum TimelineActions {
    RESET = 'timeline/RESET',
}

enum PlayerActions {
    LEVEL_LOADED_SHIFT = 'LEVEL_LOADED_SHIFT',
}

export { TimelineActions, PlayerActions };
